import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Styles */
import s from './horizontal-product.scss'

const HorizontalSkeletonCard = memo(({cardClassName}) => {
  return (
    <div className={cx(s.skeletonCard, cardClassName)}>
      <div className={s.skeletonCardImage}/>

      <div className={s.skeletonCardInfo}>
        <div>
          <div className={s.skeletonCardTitle}/>

          <div className={s.skeletonCardTitleShort}/>
        </div>

        <div className={s.skeletonCardButton}/>
      </div>
    </div>
  )
})


const HorizontalProductsSkeleton = memo(({
  cardCount,
  className,
  cardClassName
}) => {
  const arr = new Array(Math.ceil(cardCount)).fill(1);

  return (
    <div className={cx(s.root, className)}>
      <div className={s.skeletonTop}/>
      <div className={s.skeletonRow}>
        {arr.map(() => <HorizontalSkeletonCard cardClassName={cardClassName}/>)}
      </div>
    </div>
  )
})

HorizontalProductsSkeleton.defaultProps = {
  cardCount: 3,
}

HorizontalProductsSkeleton.prototype = {
  cardCount: PropTypes.number.isRequired,
  className: PropTypes.string,
  cardClassName: PropTypes.string
}

export default HorizontalProductsSkeleton
